import { Typography } from '@mui/material';
import React from 'react';
import type { CreditGrantView } from './credit-grant-view';
import { CreditsEditTable } from './CreditsEditTable';

type CreditsSectionProps = {
  rows: CreditGrantView[];
  readOnly?: boolean;
};

export const CreditsSection: React.FC<CreditsSectionProps> = ({ rows, readOnly = false }) => {
  return (
    <div className="flex w-full flex-col gap-y-4">
      <Typography className="text-base font-medium">Credits</Typography>

      {readOnly && (
        <Typography variant="body2" className="text-[#94A0A4]">
          Editing existing credits will be available soon.
        </Typography>
      )}

      <CreditsEditTable rows={rows} readOnly={readOnly} />
    </div>
  );
};
